import React, { useState, useEffect, useRef } from "react";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { CircularProgress } from '@mui/material';
import { useLocation } from 'react-router-dom';

import {
  CButton,
  CFormInput,
  CInputGroup,
  CFormLabel,
} from '@coreui/react';
import { useNavigate } from 'react-router-dom';
import { IoMdArrowRoundBack } from "react-icons/io";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import { ShimmerTable } from "react-shimmer-effects";
import { validateEntityName } from '../../../../helpers/validation';

const EditAssetGroup = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [assetGroupName, setAssetGroupName] = useState("");
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const [assetGroup, setAssetGroup] = useState({});
  const [assetGroupId, setAssetGroupId] = useState('');

  const [error, setError] = useState('');
  const [submissionSuccess, setSubmissionSuccess] = useState(false);

  const toaster = useRef();

  useEffect(() => {
    window.scrollTo(0, 0);
    var arr = location.search.split('=');
    var theAssetGroupId = arr[1];
    setAssetGroupId(theAssetGroupId);
    loadAssetGroupDetails(theAssetGroupId);
  }, []);

  const loadAssetGroupDetails = async (theAssetGroupId) => {
    setLoading(true);
    const token = sessionStorage.getItem('ASIToken');
    try {
      const response = await axios.get('api/v1/organizations/asset-groups/'+theAssetGroupId, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setAssetGroup(response.data.data);
      setAssetGroupName(response.data.data.name);
    } catch (error) {
      console.error("Error loading asset group details:", error);
      setError("Failed to load asset group details. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const validateForm = () => {
    if (!validateEntityName(assetGroupName)) {
      setError('Invalid asset group name. Only letters, numbers, spaces, underscores, dots, #, @ and hyphens are allowed (max 100 characters).');
      return false;
    }
    setError('');
    return true;
  };

  const editAssetGroup = () => {
    if (validateForm()) {
      setSubmitting(true);
      const bearerToken = sessionStorage.getItem('ASIToken');

      const requestData = {
        id: assetGroup._id,
        name: assetGroupName,
      };

      fetch(global.backendUrl + '/api/v1/organizations/asset-groups', {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${bearerToken}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestData),
      })
        .then(response => response.json())
        .then(data => {
          if (data.hasOwnProperty('error')) {
            setError(data.error);
            setSubmitting(false);
          }
          else if (data.hasOwnProperty('err')) {
            setSubmitting(false);
            setError("Something went wrong. Please try again");
          } else {
            setSubmissionSuccess(true);
            setSubmitting(false);
            toast('Asset group updated', {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
            navigate('/asset-groups');
          }
        })
        .catch(error => {
          console.error(error);
          setSubmitting(false);
          setError("An error occurred. Please try again.");
        });
    }
  };

  const goBack = (e) => {
    e.preventDefault();
    navigate('/asset-groups');
  };

  return (
    <div style={{ display: 'flex', overflow: "scroll", position: 'relative', overflowY: 'hidden', overflowX: 'hidden', }}>
      <div style={{ width: '60%' }}>
        <div>
          <div style={{ marginBottom: '0rem', display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
            <h2>Editing Asset Group</h2>
            <CButton
              onClick={goBack}
              style={{
                width: 300,
                marginBottom: '2%',
                marginRight: 20,
                borderWidth: 0,
                fontSize: 20,
                borderColor: '#fff',
                borderWidth: 1,
                color: '#fff',
                background: 'transparent'
              }}
              color="primary"
              className="px-3"
            >
              <IoMdArrowRoundBack size={25} style={{ color: '#fff', marginRight: 10 }} />
              Back to Asset Groups
            </CButton>
          </div>

          {loading ? (
            <ShimmerTable row={8} col={10} />
          ) : (
            <div style={{ width: '100%', backgroundColor: '#252B3B', padding: 15 }}>
              <CFormLabel htmlFor="formFileSm" style={{ marginTop: 30, color: 'white' }}>Asset Group Name</CFormLabel>
              <CInputGroup className="" style={{ flexDirection: 'column' }}>
                <CFormInput
                  placeholder="Asset Group Name"
                  autoComplete="assetGroupName"
                  className="white-input"
                  onChange={(e) => setAssetGroupName(e.target.value)}
                  value={assetGroupName}
                  style={{ width: '100%' }}
                  maxLength={100}
                />
                {error && <div style={{ color: 'red', marginTop: '5px' }}>{error}</div>}
              </CInputGroup>

              <CButton
                style={{
                  width: '100%',
                  marginTop: '3%',
                  marginBottom: '2%',
                  borderWidth: 0,
                  fontSize: 20,
                  background: '#e50202'
                }}
                color="primary"
                className="px-3"
                onClick={editAssetGroup}
                disabled={submitting}
              >
                {submitting ?
                  <CircularProgress color="primary" size={24} style={{ marginTop: 10, color: '#fff' }} />
                  :
                  'Save Asset Group'
                }
              </CButton>
            </div>
          )}
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default EditAssetGroup;